import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import { setupSentry } from './sentry';
import './assets/scss/main.scss';
import { flushQueuedBugReports } from './utils/bugReports';
import { watchViewport } from './utils/viewport';
import { trackUsage } from './utils/usage.js';
import './utils/screenPin.js'; // keeps the bug button at the real bottom of the screen (iOS cuts the page short)
import { installPadNav } from './utils/padNav.js';

// One anonymous ping per open → Bug Desk's Visitors tab (house module).
trackUsage('no-thanks');

// Before the first paint: how much of the screen the layout actually
// reaches. See utils/viewport - this is the dead-band seatbelt.
watchViewport();

const app = createApp(App);
// Crash reporting → Sentry → Bug Desk (src/sentry.js). Production builds only.
setupSentry(app);
app.use(store).mount('#app');

// Replay any bug report that was written while offline. Silent - see
// utils/bugReports.js.
flushQueuedBugReports();

// Production-only service worker (vite.config.js configures workbox's
// GenerateSW there, via vite-plugin-pwa). Offline play matters here for the same reason it does in
// space-base: the whole game runs client-side, so once the shell and the 33
// card JPEGs are cached there is nothing a network is needed for.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.BASE_URL}service-worker.js`).catch(() => {
      // A failed registration must never stop the app from running.
    });
  });
}

// A game controller moves a highlight round the screen and presses things
// (Steam Deck, 2026-11-02). Inert until a pad is connected.
installPadNav();
